import { createStandardAction } from 'typesafe-actions';

export const toggleChatbot = createStandardAction(
  '@COMMON/TOGGLE_CHATBOT',
)<boolean>();
